import { Component, Prop, Vue} from "vue-property-decorator";
import { TextInputModuleModel, TextInputModuleOption, ConfiguratorValueUpdateModel, configuratorConstants } from "../models";
import HtmlElementHelper from "@/services/HtmlElementHelper";
import { productConfiguratorStore as configuratorstore } from "../store";
import { EventBus } from "../../../events";

@Component
export default class TextInputModule extends Vue {

    @Prop()
    protected vm!: TextInputModuleModel<any>;
    protected backgroundColor: object = {} as object;

    protected created() {
        this.vm.options.forEach(option => {
            if (Number(option.value)) {
                const updateModel: ConfiguratorValueUpdateModel = { moduleId: this.vm.id, value: option.value,
                valueDescriptions : [{ title: "", text: option.value + option.unit }], propertyName: option.configuratorProperty.propertyName, isText: false,
                resetClimateSavingsCookie: false };
                configuratorstore.updateConfiguratorValue(updateModel);
            }

            if (!option.value) {
                option.value = "";
            }
        });
        if (this.vm.backgroundColor) {
            this.backgroundColor = { "background-color": this.vm.backgroundColor };
        }
    }

    protected mounted() {
        EventBus.$on("updateoutercorners", () => {
            const tempOptions = this.vm.options;
            const option = tempOptions.find(b => b.configuratorProperty.propertyName === configuratorConstants.OuterCorners);
            const optionInner = tempOptions.find(b => b.configuratorProperty.propertyName === configuratorConstants.InnerCorners);
            if (option) {
                this.vm.options = [];
                const updatedValueOption = configuratorstore.configuratorValues.find(a => a.property.propertyName === configuratorConstants.OuterCorners);
                if (updatedValueOption) {
                    option.value = updatedValueOption.value;
                    this.vm.options = tempOptions;
                }
            }
            if (optionInner) {
                this.vm.options = [];
                const updatedValueOption = configuratorstore.configuratorValues.find(a => a.property.propertyName === configuratorConstants.InnerCorners);
                if (updatedValueOption) {
                    optionInner.value = updatedValueOption.value;
                    this.vm.options = tempOptions;
                }
            }
        });

        EventBus.$on("onfloortypeupdate", () => {
            const tempOptions = this.vm.options;
            const option = tempOptions.map(item => {
                if (configuratorConstants.ResetPropertiesOnFloorChange.indexOf(item.configuratorProperty.propertyName + ";") > -1) {
                    item.value = undefined;
                }
            });
            this.vm.options = tempOptions;
        });
    }

    protected handleDebounce(propertyValue: any, event: Event) {
        const propertyNamedataElement: string = "propertyName";
        const propertyUnitDataElement: string = "propertyUnit";
        if (event.target instanceof HTMLInputElement && HtmlElementHelper.isFocusedElement(event.target)) {
            if (event.target.type === "number" && !HtmlElementHelper.isValidNumberInput(event.target)) {
                return;
            }
            const propertyName = event.target.dataset[propertyNamedataElement];
            const propertyUnit = event.target.dataset[propertyUnitDataElement] || "";
            if (propertyName !== undefined) {
                this.setOptionValue(propertyName, propertyValue, propertyUnit, true);
            }
        }
    }

    protected handleBlur(option: TextInputModuleOption<any>, event: Event) {
        if (event.target instanceof HTMLInputElement && event.target.type === "number" && !HtmlElementHelper.isValidNumberInput(event.target)) {
            event.target.value = event.target.min;
            option.value = Number(event.target.min);
        }

        this.setOptionValue(option.configuratorProperty.propertyName, option.value, option.unit, true);
    }

    protected setOptionValue(propertyName: string, propertyValue: any, propertyUnit: string, setCookie: boolean = false) {
        const updateModel: ConfiguratorValueUpdateModel = { moduleId: this.vm.id, value: propertyValue, valueDescriptions: [{ title: "", text: `${propertyValue} ${propertyUnit}` }],
        propertyName, isText: true, resetClimateSavingsCookie: false };
        this.$emit("update-configurator-value", updateModel, setCookie);
    }
}
